import "./Loader.css";

export default function Loader() {
  return (
    <div className="loader-wrapper">

      <div className="loader-ring">
        <div className="loader-inner"></div>
      </div>

      <h2 className="loader-text">Scan & Order</h2>
      <p className="loader-sub">Loading your experience...</p>

    </div>
  );
}